export const SSO_CALLBACK_CONTAINER_TAG_NAME = 'sso-callback-container';
